import getChangeLogName from './get-change-log-name';
import IconArrowRight from '../../icons/arrow-right';
import formatDate from '../../../helpers/format-date';
import { ChangeLogItemTypes } from './types';

import styles from '../transaction.module.css';

export default function ChangeLogItem({
  changeLog,
  pspPartners,
}: ChangeLogItemTypes) {
  const names = Object.keys(
    changeLog?.prev as Record<string, string | number>,
  );

  return (
    <div className={styles.changeLogItem}>
      {names.map((item) => {
        let prevValue = changeLog?.prev[item];
        let nextValue = changeLog?.next[item];
        let content;

        if (nextValue) {
          if (item === 'pspPartnerId') {
            prevValue = pspPartners?.find(
              (partner) => partner.value === prevValue,
            )?.name;

            nextValue = pspPartners?.find(
              (partner) => partner.value === nextValue,
            )?.name;
          }

          if (item === 'acceptedIn') {
            if (prevValue !== null) {
              prevValue = formatDate(prevValue as string, true);
            }

            if (nextValue !== null) {
              nextValue = formatDate(nextValue as string, true);
            }
          }

          if (item === 'exchangeDateOfRate') {
            if (prevValue !== null) {
              prevValue = formatDate(prevValue as string, true);
            }

            if (nextValue !== null) {
              nextValue = formatDate(nextValue as string, true);
            }
          }

          content = (
            <div className={styles.changeLogItemTop} key={item}>
              <span className={styles.changeLogItemTopTitle}>
                {getChangeLogName(item)}
              </span>
              <span>
                {prevValue === null || prevValue === undefined
                  ? `${prevValue}`
                  : prevValue}
              </span>
              <IconArrowRight className={`icon-small ${styles.icon}`} />
              <span>
                {nextValue === null || nextValue === undefined
                  ? `${nextValue}`
                  : nextValue}
              </span>
            </div>
          );
        }

        return content;
      })}
    </div>
  );
}
